import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useCallback, useEffect } from "react";

import { CapsState } from "../store/reducers/Caps";
import { getCaps } from "../store/actions/Caps";
import { RootState } from "../store/store";

export const useCaps = (): [CapsState] => {
  const capsState = useSelector<RootState, CapsState>(
    (x) => x.Caps,
    shallowEqual
  );
  const dispatch = useDispatch();
  const boundAction = useCallback(() => {
    dispatch(getCaps());
  }, [dispatch]);
  useEffect(() => {
    if (!capsState.fetching && !capsState.receivedAt) {
      boundAction();
    }
  }, [boundAction, capsState]);

  return [capsState];
};
